export function newBroadcastChannel(): BroadcastChannel {
  return new BroadcastChannel('iam.external');
}
